import React, { memo, useCallback } from "react";
import PropTypes from "prop-types";
import VehicleCard, { VehicleCardSizeType, VehicleCardVariantType } from "../../../vehicles/VehicleCard";
import { pushSegmentAnalyticsTrack } from "utils/segment-analytics/push";
import { FormattedTextPrice } from "components/FormattedTextPrice/FormattedTextPrice";

/**
 * VehicleCard Search API Bridge
 */
const VehicleCardBridge = (props) => {
  const {
    photoUrlPrefix,
    linkPrefix,
    item,
    itemIndex,
    isInFavorites,
    onChangeFavorite,
    onPriceTotalClick,
    userId,
    filterRentalType,
    ...other
  } = props;

  const onClickCardLink = useCallback(() => {
    pushSegmentAnalyticsTrack("Product Clicked", {
      location: String(item?.lc?.replace('Delivered from ', '')),
      asset_make: String(item.mk),
      asset_model: String(item.md),
      asset_year: String(item.yr),
      asset_length: Number(item.le) * 12,
      asset_sleepnumber: Number(item.sl),
      asset_class: String(item.cl),
      asset_id: String(item.id),
      asset_price: Number(item.pr),
      asset_brand: item.mr,
      asset_slideouts: Number(item.so),
      cwh_business: 'RV Rentals',
      fbp: "",
      fbc: ""
    });
  }, [item]);

  const price = (
    <FormattedTextPrice
      cents={filterRentalType === 1 ? item.pt : item.po}
    />
  );
  return (
    <VehicleCard
      {...other}
      imageUrl={`${photoUrlPrefix}${item.ph}`}
      link={`${linkPrefix}${item.ur}`}
      linkTarget="_blank"
      id={item.id}
      title={item.ti}
      name={item.nm}
      price={price}
      price_per_night={item.pr}
      nights={item.mn}
      deliveredFrom={item.lc}
      rvClass={item.cl}
      miles={item.ml}
      length={item.le}
      sleeps={item.sl}
      slideOuts={item.so}
      instantRentals={item.ir}
      rentalType={item.rt}
      isFavorite={isInFavorites(item.id)}
      onClickCardLink={onClickCardLink}
      onClickFavorite={onChangeFavorite}
      onPriceTotalClick={onPriceTotalClick}
      userId={userId}
    />
  );
};

VehicleCardBridge.propTypes = {
  photoUrlPrefix: PropTypes.string.isRequired,
  linkPrefix: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
  isInFavorites: PropTypes.func.isRequired,
  onChangeFavorite: PropTypes.func.isRequired,
  filterRentalType: PropTypes.number,
  // Other from VehicleCard:
  className: PropTypes.string,
  variant: VehicleCardVariantType,
  size: VehicleCardSizeType,
  onClose: PropTypes.func,
  pageIndex: PropTypes.number,
  totalPages: PropTypes.number,
  onClickPrevious: PropTypes.func,
  onClickNext: PropTypes.func,
  onPriceTotalClick: PropTypes.func
};

export default memo(VehicleCardBridge);
